export default __webpack_public_path__ + "static/media/redo-icon.0df7bca0.svg";